import register from '@kpsys/angularjs-register';
import RecordDataService from './record.data-service';
import ForeignDocumentDataService from './kp-find-in-databases/foreign-document.data-service';
import AvailabilityDataService from './availability.data-service';
import ExemplarPlacementDataService from './exemplar-placement.data-service';
import ExemplarPlacementPresenter from './kp-exemplars-list/components/exemplar-placement.presenter';
import ExemplarService from './exemplar.service';
import {VolumeDataService} from './kp-volumes/volume.data-service';
import ExemplarDataService from './exemplar.data-service';
import VolumeService from './kp-volumes/volume.service';
import RecordService from './record.service';
import RatingDataService from './kp-rating/rating.data-service';
import KpDocumentsSliderComponent from './kp-documents-slider/kp-documents-slider.component';
import {RecordCoverService} from './kp-cover/record-cover.service';
import {KpDocumentMiniPresenter} from './kp-document-mini/kp-document-mini.presenter';
import {KpFindInDatabasesPresenter} from './kp-find-in-databases/kp-find-in-databases.presenter';
import {CitationDataService} from './kp-citation/citation.data-service';
import {CitationPresenter} from './kp-citation/citation.presenter';
import {KpExemplarsListPresenter} from './kp-exemplars-list/kp-exemplars-list.presenter';
import JpSliderComponent from './jp-slider/jp-slider.component';
import KpCarouselComponent from './kp-carousel/kp-carousel.component';
import kpClipboardModule from './kp-record-clipboard/kp-clipboard-panel.module';
import visitedPanelComponentModule from './kp-visited-documents-panel/kp-visited-panel.module';
import kpNewDocumentsModule from './kp-new-documents/kp-new-documents.module';
import kpDocumentsCarouselModule from './kp-documents-carousel/kp-documents-carousel.module';
import ObservableRecordDataService from './observable-record.data-service';
import ObservableExemplarDataService from './observable-exemplar.data-service';
import {KpRatingPresenter} from './kp-rating/kp-rating.presenter';
import {KpCommentsPresenter} from './kp-comments/kp-comments.presenter';
import CommentsDataService from './kp-comments/comments.data-service';
import {KpExemplarsPresenter} from './kp-exemplars/kp-exemplars.presenter';
import {KpVolumesPresenter} from './kp-volumes/kp-volumes.presenter';
import {AuthorityDetailTabsetService} from './kp-authority-detail-tabset/authority-detail-tabset.service';
import {DocumentDetailTabsetService} from './kp-document-detail-tabset/document-detail-tabset.service';
import {KpDocumentDetailPageService} from './kp-document-detail-page/kp-document-detail-page.service';
import {KpAuthorityDetailPageService} from './kp-authority-detail-page/kp-authority-detail-page.service';
import {SimilarDocumentsDataService} from './similar-documents.data-service';
import {KpRelatedRecordsTablePresenter} from './kp-related-records-table/kp-related-records-table.presenter';
import {RecordCoverDataService} from './kp-cover/record-cover.data-service';
import recordRoutes from './record.routes';
import uiRouter from '@uirouter/angularjs';
import {registerDocumentDetailsInterceptors} from './kp-record-detail-page/register-interceptios';
import {FieldTypeDataService} from './field-types/field-type-data.service';
import RecordStatusService from 'src/features/record/record-status.service';
import {RecordHoldingDataService} from 'src/features/record/record-holding.data-service';
import {RecordBulkEditDataService} from 'src/features/record/record-bulk-edit.data-service';
import {RecordBulkEditService} from 'src/features/record/record-bulk-edit.service';

export default register('portaro.features.record', [
    visitedPanelComponentModule,
    kpNewDocumentsModule,
    kpClipboardModule,
    kpDocumentsCarouselModule,
    uiRouter
])
    .config(recordRoutes)
    .run(registerDocumentDetailsInterceptors)

    .service(ForeignDocumentDataService.serviceName, ForeignDocumentDataService)
    .service(AvailabilityDataService.serviceName, AvailabilityDataService)
    .service(ExemplarPlacementDataService.serviceName, ExemplarPlacementDataService)
    .service(ExemplarPlacementPresenter.serviceName, ExemplarPlacementPresenter)
    .service(ExemplarDataService.serviceName, ExemplarDataService)
    .service(ExemplarService.serviceName, ExemplarService)
    .service(RecordDataService.serviceName, RecordDataService)
    .service(RecordHoldingDataService.serviceName, RecordHoldingDataService)
    .service(RecordService.serviceName, RecordService)
    .service(VolumeDataService.serviceName, VolumeDataService)
    .service(VolumeService.serviceName, VolumeService)
    .service(RatingDataService.serviceName, RatingDataService)
    .service(RecordCoverService.serviceName, RecordCoverService)
    .service(KpDocumentMiniPresenter.presenterName, KpDocumentMiniPresenter)
    .service(KpFindInDatabasesPresenter.presenterName, KpFindInDatabasesPresenter)
    .service(KpExemplarsListPresenter.presenterName, KpExemplarsListPresenter)
    .service(CitationDataService.serviceName, CitationDataService)
    .service(CitationPresenter.presenterName, CitationPresenter)
    .service(ObservableExemplarDataService.serviceName, ObservableExemplarDataService)
    .service(ObservableRecordDataService.serviceName, ObservableRecordDataService)
    .service(CommentsDataService.serviceName, CommentsDataService)
    .service(KpRatingPresenter.presenterName, KpRatingPresenter)
    .service(KpCommentsPresenter.presenterName, KpCommentsPresenter)
    .service(KpExemplarsPresenter.presenterName, KpExemplarsPresenter)
    .service(KpVolumesPresenter.presenterName, KpVolumesPresenter)
    .service(AuthorityDetailTabsetService.serviceName, AuthorityDetailTabsetService)
    .service(DocumentDetailTabsetService.serviceName, DocumentDetailTabsetService)
    .service(SimilarDocumentsDataService.serviceName, SimilarDocumentsDataService)
    .service(KpRelatedRecordsTablePresenter.presenterName, KpRelatedRecordsTablePresenter)
    .service(RecordCoverDataService.serviceName, RecordCoverDataService)
    .service(RecordStatusService.serviceName, RecordStatusService)
    .service(FieldTypeDataService.serviceName, FieldTypeDataService)
    .component(KpCarouselComponent.componentName, KpCarouselComponent)
    .component(JpSliderComponent.componentName, JpSliderComponent)
    .component(KpDocumentsSliderComponent.componentName, KpDocumentsSliderComponent)

    // Bulk edit services
    .service(RecordBulkEditDataService.serviceName, RecordBulkEditDataService)
    .service(RecordBulkEditService.serviceName, RecordBulkEditService)

    // Services for detail pages
    .service(KpDocumentDetailPageService.serviceName, KpDocumentDetailPageService)
    .service(KpAuthorityDetailPageService.serviceName, KpAuthorityDetailPageService)

    .name();